import React, { memo } from "react";
import Div100vh from "react-div-100vh";
import { use100vh } from "react-div-100vh";
import { Bot } from ".";
import useStylesChatContainer from "../../atoms/chatContainerStyle";
import { Header } from "./Header";

const BotContainer = memo(() => {
  const height = use100vh();
  const styles = useStylesChatContainer({ height });

  return (
    <Div100vh className={styles.container}>
      <Bot headerComponent={<Header />} />
    </Div100vh>
  );
});

export { BotContainer };
